<template>
    <div class="module__edit_versions">
        <component-list
            :component-table="ModuleEditVersionsTable"
            :item-name="['version', 'versions']"
            :filters-active="false"
            :get-items-getter="'getEbsModuleVersions'"
        />
    </div>
</template>

<script>

import ComponentList from '@/components/default/shared/ComponentList'
import ModuleEditVersionsTable from '@/components/ebs/modules/edit/ModuleEditVersionsTable'

export default {
  name: 'module-edit-versions',
  components: { ComponentList },
  data () {
    return {
      ModuleEditVersionsTable
    }
  },
  computed: {
    rootItemName () {
      return 'module'
    },
    //
    isAddMode () {
      return this.$route.name.includes('module-add')
    },
    isEditMode () {
      return this.$route.name.includes('module-edit')
    },
    isShowMode () {
      return this.$route.name.includes('module-show')
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/modules/moduleaddeditversions";
</style>
